// extracted by mini-css-extract-plugin
export default {"component":"arrow-button__jRNZ4"};